// “ctrl + click” | “cmd + click”
export const isNewTabKey = (event: MouseEvent): boolean => {
  event.preventDefault();
  event.stopPropagation();

  return event.type === 'click' && (event.ctrlKey || event.metaKey);
};
